import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from "react";
import { formatNumber } from "accounting";

var ProgressText = function ProgressText(_ref) {
  var progress = _ref.progress,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["progress", "component"]);

  if (!progress) return null;
  var success = progress.success,
      failed = progress.failed,
      total = progress.total;
  var Component = component || "span";
  var text = "";

  if (success && success === total) {
    return /*#__PURE__*/React.createElement(Component, props, formatNumber(success), " successful items");
  }

  if (failed && failed === total) {
    return /*#__PURE__*/React.createElement(Component, props, formatNumber(failed), " failed items");
  }

  if (success) {
    text += formatNumber(success) + " successful";
  }

  if (failed) {
    if (text) {
      text += ", " + formatNumber(failed) + " failed";
    } else {
      text += formatNumber(failed) + " failed";
    }
  }

  if (total) {
    if (text) {
      text += " out of " + formatNumber(total);
    } else {
      text += formatNumber(total) + " unprocessed";
    }
  }

  if (!text) return null;
  return /*#__PURE__*/React.createElement(Component, props, text);
};

export default ProgressText;